export default __webpack_public_path__ + "static/media/pemilu.6b421e59.png";